import { CardContent } from '@shared/models/card.interface';

//* Core
import { WellKnownRoutes } from '@core/enums';

//* Shared
import { CardIcon, CardLabel, CardTitle } from '@shared/enums';

export class Card {
  static titles = [
    CardTitle.Personal,
    CardTitle.Contact,
    CardTitle.Address,
    CardTitle.BankAccount,
    CardTitle.FederalTaxes,
    CardTitle.StateTaxes,
  ];
  static labels = {
    personal: [CardLabel.Name, CardLabel.SSN, CardLabel.Birthdate, CardLabel.Sex],
    contact: [
      CardLabel.MobilePhone,
      CardLabel.HomePhone,
      CardLabel.Email,
      CardLabel.EmergencyContact,
    ],
    /** //* Card has no labels: Design Decision. ¯\_(ツ)_/¯ */
    address: ['', '', ''],
    /** //* Card has new layout with table 3 possible bank Account data table rows */
    bankAccounts: ['', '', ''],
    federalTaxes: {
      '2019': [
        CardLabel.FilingStatus,
        CardLabel.ExtraWithholding,
        CardLabel.WithholdingTax,
        CardLabel.Allowances,
      ],
      '2020+': [
        CardLabel.FilingStatus,
        CardLabel.OtherIncome,
        CardLabel.WithholdingTax,
        CardLabel.Deductions,
        CardLabel.MultipleJobsOrSpouse,
        CardLabel.ExtraWithholding,
        CardLabel.ClaimDependentsAmount,
      ],
    },
    stateTaxes: [
      CardLabel.IncomeState,
      CardLabel.ExtraWithholding,
      CardLabel.FilingStatus,
      CardLabel.UnemploymentFilingState,
      CardLabel.WithholdingTax,
      CardLabel.Allowances,
    ],
  };
  static icons = [
    CardIcon.User,
    CardIcon.Mobile,
    CardIcon.Home,
    CardIcon.University,
    CardIcon.File,
    CardIcon.File,
  ];
  static links = [
    WellKnownRoutes.Personal,
    WellKnownRoutes.Personal,
    WellKnownRoutes.Address,
    WellKnownRoutes.Personal,
    WellKnownRoutes.TaxForms,
    WellKnownRoutes.TaxForms,
  ];
  static isEditable = [true, true, false, false, false, false];
  static content: CardContent[];
}
